import React, { useEffect } from "react";

import { Card, Collapse, Grid, MenuItem } from "@mui/material";

import CardBody from "../../../components/Card/CardBody";

import { useController, useWatch } from "react-hook-form";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import FormSwitch from "../../../components/Forms/FormSwitch";
import Box from "@mui/material/Box";

function MultiAreaSync() {
  const customizableTranslationsEnabled = useWatch({ name: "multi_sales_area_sync:customizable_translation" });
  const upsellEnabled = useWatch({ name: "multi_sales_area_sync:upsell" });
  const upsellSettingEnabled = useWatch({ name: "multi_sales_area_sync:upsell_setting" });
  const packagingsEnabled = useWatch({ name: "multi_sales_area_sync:packagings" });
  const packagingTypesEnabled = useWatch({ name: "multi_sales_area_sync:packaging_types" });
  const productEnabled = useWatch({ name: "multi_sales_area_sync:product" });
  const tagEnabled = useWatch({ name: "multi_sales_area_sync:tags" });
  const salesAreaPriceLinesEnabled = useWatch({ name: "multi_sales_area_sync:sales_area_price_line" });
  const categoryEnabled = useWatch({ name: "multi_sales_area_sync:menukaart" });
  const optionGroupEnabled = useWatch({ name: "multi_sales_area_sync:option_group" });
  const campaignEnabled = useWatch({ name: "multi_sales_area_sync:campaign" });
  const customData = useWatch({ name: "custom_data" });
  const optionGroupPivot = useWatch({ name: "multi_sales_area_sync_pivot:option_group-product" });

  const {
    field: { onChange: onChangePackageCreateMissing },
  } = useController({ name: "multi_sales_area_sync_createMissing:packaging_types" });
  const {
    field: { onChange: onChangePackageType },
  } = useController({ name: "multi_sales_area_sync:packaging_types" });

  useEffect(() => {
    if (packagingsEnabled) {
      onChangePackageCreateMissing(true);
      onChangePackageType(true);
    }
  }, [packagingsEnabled, onChangePackageCreateMissing, onChangePackageType]);

  return (
    <>
      <h4>
        <TranslationWrapper tDefault={"MAPPS"} tKey={"multi_area_sync_parent_settings.mapps"} />
      </h4>
      <div>
        <Card style={{ marginBottom: "10px", width: "100%" }}>
          <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
            <Grid container spacing={1}>
              <div style={{ display: "flex", padding: "10px 0 0 10px" }}>
                <h4>
                  <TranslationWrapper tDefault={"Parent"} tKey={"custom_data.multi_sales_area_sync.is_master"} />
                </h4>
                <FormSwitch
                  name={"custom_data.multi_sales_area_sync.isParent"}
                  tDefault={"Parent"}
                  tKey={"custom_data.multi_sales_area_sync.is_master"}
                />
              </div>
            </Grid>
          </CardBody>
        </Card>

        <Collapse in={!!customData?.multi_sales_area_sync?.isParent}>
          <h4>
            <TranslationWrapper tDefault={"Parent Settings"} tKey={"multi_area_sync_parent_settings"} />
          </h4>

          <Card style={{ margin: "10px", width: "100%" }}>
            <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
              <Grid container spacing={1}>
                <FormAsyncTC
                  async={{
                    url: "core/vestigingen/search?fields=id as value, systeemNaam as label&per_page=200&sort_field=systeemNaam",
                    searchField: "systeemNaam",
                  }}
                  multiple={true}
                  name={"custom_data.multi_sales_area_sync.children"}
                  nullable={true}
                  tDefault={"Follower salesareas"}
                  tKey={"vestigingen.form.algemeen.label.mapps"}
                />
                <FormSelectTC
                  defaultValue={"apiId1"}
                  name={"custom_data.multi_area_sync_product_match_field"}
                  options={[
                    <MenuItem key={"apiId1"} value={"apiId1"}>
                      <TranslationWrapper tDefault={"Api ID"} tKey={"multi_area_sync_parent_settings_api_id"} />
                    </MenuItem>,
                    <MenuItem key={"naam"} value={"naam"}>
                      <TranslationWrapper tDefault={"Name"} tKey={"multi_area_sync_parent_settings_name"} />
                    </MenuItem>,
                    <MenuItem key={"snaam"} value={"snaam"}>
                      <TranslationWrapper
                        tDefault={"System name"}
                        tKey={"multi_area_sync_parent_settings_system_name"}
                      />
                    </MenuItem>,
                    <MenuItem key={"mapps_uuid"} value={"mapps_uuid"}>
                      <TranslationWrapper tDefault={"Uuid"} tKey={"multi_area_sync_parent_settings_uuid"} />
                    </MenuItem>,
                  ]}
                  tDefault={"Product match type"}
                  tKey={"multi_area_sync_product_match_column"}
                />
                <FormSelectTC
                  defaultValue={"naam"}
                  name={"custom_data.multi_area_sync_category_match_field"}
                  options={[
                    <MenuItem key={"naam"} value={"naam"}>
                      <TranslationWrapper tDefault={"Name"} tKey={"multi_area_sync_parent_settings_name"} />
                    </MenuItem>,
                    <MenuItem key={"snaam"} value={"snaam"}>
                      <TranslationWrapper
                        tDefault={"System name"}
                        tKey={"multi_area_sync_parent_settings_system_name"}
                      />
                    </MenuItem>,
                    <MenuItem key={"mapps_uuid"} value={"mapps_uuid"}>
                      <TranslationWrapper tDefault={"Uuid"} tKey={"multi_area_sync_parent_settings_uuid"} />
                    </MenuItem>,
                  ]}
                  tDefault={"Category match type"}
                  tKey={"multi_area_sync_product_match_column"}
                />
                <FormSelectTC
                  defaultValue={"name"}
                  name={"custom_data.multi_area_sync_campaign_match_field"}
                  options={[
                    <MenuItem key={"name"} value={"name"}>
                      <TranslationWrapper tDefault={"Name"} tKey={"multi_area_sync_parent_settings_campaign_name"} />
                    </MenuItem>,
                    <MenuItem key={"api_name"} value={"api_name"}>
                      <TranslationWrapper
                        tDefault={"System name"}
                        tKey={"multi_area_sync_parent_settings_campaign_api_name"}
                      />
                    </MenuItem>,
                    <MenuItem key={"apiId1"} value={"apiId1"}>
                      <TranslationWrapper tDefault={"Api ID"} tKey={"multi_area_sync_parent_settings_api_id"} />
                    </MenuItem>,
                    <MenuItem key={"mapps_uuid"} value={"mapps_uuid"}>
                      <TranslationWrapper tDefault={"Uuid"} tKey={"multi_area_sync_parent_settings_uuid"} />
                    </MenuItem>,
                  ]}
                  tDefault={"Campaign match type"}
                  tKey={"multi_area_sync_campaign_match_column"}
                />
              </Grid>
            </CardBody>
          </Card>
        </Collapse>
      </div>

      <Collapse in={!customData?.multi_sales_area_sync?.isParent}>
        <h4>
          <TranslationWrapper tDefault={"Follower Settings"} tKey={"multi_area_sync_child_settings"} />
        </h4>
        <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "flex-start", alignItems: "flex-start", gap: 4 }}>
          <Card>
            <div style={{ display: "flex", padding: "10px 0 0 10px" }}>
              <h4>
                <TranslationWrapper tDefault={"Producten"} tKey={"multi_area_sync_child_settings_products"} />
              </h4>
              <FormSwitch
                name={"multi_sales_area_sync:product"}
                tDefault={"Product"}
                tKey={"multi_sales_area_sync:product"}
              />
            </div>
            <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
              <Grid container spacing={1}>
                <Collapse in={productEnabled} sx={{ width: 1 }}>
                  <FormSwitchTC
                    name={"multi_sales_area_sync_createMissing:product"}
                    tDefault={"Create Products"}
                    tKey={"multi_sales_area_sync_createMissing:product"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_cascadeDelete:product"}
                    tDefault={"Delete Products"}
                    tKey={"multi_sales_area_sync_cascadeDelete:product"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-naam"}
                    tDefault={"Product naam"}
                    tKey={"multi_sales_area_sync_model:product-naam"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-omschrijving"}
                    tDefault={"Product omschrijving"}
                    tKey={"multi_sales_area_sync_model:product-omschrijving"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-sortkey"}
                    tDefault={"Sort key"}
                    tKey={"multi_sales_area_sync_model:product-sortkey"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-apiId1"}
                    tDefault={"ApiId1"}
                    tKey={"multi_sales_area_sync_model:product-apiId1"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-prijs"}
                    tDefault={"Price (Warning: Mismatches between POS and Jamezz can cause errors)"}
                    tKey={"multi_sales_area_sync_model:product-prijs"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-blocked"}
                    tDefault={
                      "Blocked (Warning: You probably shouldn't be using this, because blocked must probably be controlled in each distinct salesarea)"
                    }
                    tKey={"multi_sales_area_sync_model:product-blocked"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-depositId"}
                    tDefault={"Product deposit"}
                    tKey={"multi_sales_area_sync_model:product-depositId"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-allergenen"}
                    tDefault={"Product allergens"}
                    tKey={"multi_sales_area_sync_model:product-allergenen"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-translations"}
                    tDefault={"Product translations"}
                    tKey={"multi_sales_area_sync_model:product-translations"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_media:product-imgid"}
                    tDefault={"Product media"}
                    tKey={"multi_sales_area_sync_media:product-imgid"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_relation:product-tags"}
                    tDefault={"Product tag relation"}
                    tKey={"multi_sales_area_sync_relation:product-tags"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_relation:product-menukaarten"}
                    tDefault={"Product menukaart relation"}
                    tKey={"multi_sales_area_sync_relation:product-menukaarten"}
                  />

                  <h5>
                    <TranslationWrapper
                      tDefault={"Producten upsells"}
                      tKey={"multi_area_sync_child_settings_product_upsells"}
                    />
                  </h5>
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-freeOptionsTitle"}
                    tDefault={"Title optional upsell 1"}
                    tKey={"multi_sales_area_sync_model:product-freeOptionsTitle"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-freeOptionsTitle2"}
                    tDefault={"Title optional upsell 1"}
                    tKey={"multi_sales_area_sync_model:product-freeOptionsTitle2"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-freeOptionsTitle3"}
                    tDefault={"Title optional upsell 3"}
                    tKey={"multi_sales_area_sync_model:product-freeOptionsTitle3"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-freeOptions"}
                    tDefault={"Optional upsell 1"}
                    tKey={"multi_sales_area_sync_model:product-freeOptions"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-freeOptions2"}
                    tDefault={"Optional upsell 2"}
                    tKey={"multi_sales_area_sync_model:product-freeOptions2"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-freeOptions3"}
                    tDefault={"Optional upsell 3"}
                    tKey={"multi_sales_area_sync_model:product-freeOptions3"}
                  />
                  <hr />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-freeOptionsRequiredTitle"}
                    tDefault={"Title mandatory upsell 1"}
                    tKey={"multi_sales_area_sync_model:product-freeOptionsRequiredTitle"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-freeOptionsRequiredTitle2"}
                    tDefault={"Title mandatory upsell 2"}
                    tKey={"multi_sales_area_sync_model:product-freeOptionsRequiredTitle2"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-freeOptionsRequiredTitle3"}
                    tDefault={"Title mandatory upsell 3"}
                    tKey={"multi_sales_area_sync_model:product-freeOptionsRequiredTitle3"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-freeOptionsRequired"}
                    tDefault={"Mandatory upsell 1"}
                    tKey={"multi_sales_area_sync_model:product-freeOptionsRequired"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-freeOptionsRequired2"}
                    tDefault={"Mandatory upsell 2"}
                    tKey={"multi_sales_area_sync_model:product-freeOptionsRequired2"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:product-freeOptionsRequired3"}
                    tDefault={"Mandatory upsell 3"}
                    tKey={"multi_sales_area_sync_model:product-freeOptionsRequired3"}
                  />
                </Collapse>
              </Grid>
            </CardBody>
          </Card>

          <Card>
            <div style={{ display: "flex", padding: "10px 0 0 10px" }}>
              <h4>
                <TranslationWrapper tDefault={"Tags"} tKey={"multi_area_sync_child_settings_tags"} />
              </h4>
              <FormSwitch name={"multi_sales_area_sync:tags"} tDefault={"Tags"} tKey={"multi_sales_area_sync:tags"} />
            </div>
            <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
              <Grid container spacing={1}>
                <Collapse in={tagEnabled} sx={{ width: 1 }}>
                  <FormSwitchTC
                    name={"multi_sales_area_sync_createMissing:tags"}
                    tDefault={"Create tags"}
                    tKey={"multi_sales_area_sync_createMissing:tags"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_cascadeDelete:tags"}
                    tDefault={"Delete tags"}
                    tKey={"multi_sales_area_sync_cascadeDelete:tags"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:tags-active"}
                    tDefault={"Tag active"}
                    tKey={"multi_sales_area_sync_model:tags-active"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:tags-tagName"}
                    tDefault={"Tag name"}
                    tKey={"multi_sales_area_sync_model:tags-tagName"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:tags-tagType"}
                    tDefault={"Tag type"}
                    tKey={"multi_sales_area_sync_model:tags-tagType"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:tags-tag_type"}
                    tDefault={"Tag type (Allergen, Preference, Brand)"}
                    tKey={"multi_sales_area_sync_model:tags-tag_type"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:tags-is_filter"}
                    tDefault={"Tag is filter"}
                    tKey={"multi_sales_area_sync_model:tags-is_filter"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:tags-show_tag"}
                    tDefault={"Tag show"}
                    tKey={"multi_sales_area_sync_model:tags-show_tag"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:tags-translations"}
                    tDefault={"Tag translations"}
                    tKey={"multi_sales_area_sync_model:tags-translations"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_media:tags-imgid"}
                    tDefault={"Tags media"}
                    tKey={"multi_sales_area_sync_media:tags-imgid"}
                  />
                </Collapse>
              </Grid>
            </CardBody>
          </Card>
          <Card>
            <div style={{ display: "flex", padding: "10px 0 0 10px" }}>
              <h4>
                <TranslationWrapper tDefault={"Price lines"} tKey={"multi_area_sync_child_settings_price_lines"} />
              </h4>
              <FormSwitch
                name={"multi_sales_area_sync:sales_area_price_line"}
                tDefault={"Sales Area Price Lines"}
                tKey={"multi_sales_area_sync:sales_area_price_line"}
              />
            </div>
            <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
              <Grid container spacing={1}>
                <Collapse in={salesAreaPriceLinesEnabled} sx={{ width: 1 }}>
                  <FormSwitchTC
                    name={"multi_sales_area_sync_createMissing:sales_area_price_line"}
                    tDefault={"Create Sales Area Price Lines"}
                    tKey={"multi_sales_area_sync_createMissing:sales_area_price_line"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_cascadeDelete:sales_area_price_line"}
                    tDefault={"Delete Sales Area Price Lines"}
                    tKey={"multi_sales_area_sync_cascadeDelete:sales_area_price_line"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:sales_area_price_line-title"}
                    tDefault={"Name"}
                    tKey={"multi_sales_area_sync_model:sales_area_price_line-title"}
                  />

                  <FormSwitchTC
                    name={"multi_sales_area_sync_relation:sales_area_price_line-product_price_lines"}
                    tDefault={"Product price lines"}
                    tKey={"multi_sales_area_sync_relation:sales_area_price_line-product_price_lines"}
                  />
                </Collapse>
              </Grid>
            </CardBody>
          </Card>

          <Card>
            <div style={{ display: "flex", padding: "10px 0 0 10px" }}>
              <h4>
                <TranslationWrapper tDefault={"Categories"} tKey={"multi_area_sync_child_settings_categories"} />
              </h4>
              <FormSwitch
                name={"multi_sales_area_sync:menukaart"}
                tDefault={"Category"}
                tKey={"multi_sales_area_sync:menukaart"}
              />
            </div>
            <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
              <Collapse in={categoryEnabled} sx={{ width: 1 }}>
                <FormSwitchTC
                  name={"multi_sales_area_sync_createMissing:menukaart"}
                  tDefault={"Create Categories"}
                  tKey={"multi_sales_area_sync_createMissing:menukaart"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_cascadeDelete:menukaart"}
                  tDefault={"Delete Categories"}
                  tKey={"multi_sales_area_sync_cascadeDelete:menukaart"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_model:menukaart-naam"}
                  tDefault={"Category name"}
                  tKey={"multi_sales_area_sync_model:menukaart-naam"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_model:menukaart-titleMenuDescr"}
                  tDefault={"Short description"}
                  tKey={"multi_sales_area_sync_model:menukaart-titleMenuDescr"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_model:menukaart-bigdescr"}
                  tDefault={"Description"}
                  tKey={"multi_sales_area_sync_model:menukaart-bigdescr"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_model:menukaart-blocked"}
                  tDefault={
                    "Blocked (Warning: You probably shouldn't be using this, because blocked must probably be controlled in each distinct salesarea)"
                  }
                  tKey={"multi_sales_area_sync_model:menukaart-blocked"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_model:menukaart-categorie"}
                  tDefault={"Supergroup"}
                  tKey={"multi_sales_area_sync_model:menukaart-categorie"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_model:menukaart-columnCount"}
                  tDefault={"Column count"}
                  tKey={"multi_sales_area_sync_model:menukaart-columnCount"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_model:menukaart-translations"}
                  tDefault={"Category translations"}
                  tKey={"multi_sales_area_sync_model:menukaart-translations"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_model:menukaart-showInCategoryMenu"}
                  tDefault={"Display in category"}
                  tKey={"multi_sales_area_sync_model:menukaart-showInCategoryMenu"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_media:menukaart-imgid"}
                  tDefault={"Category image"}
                  tKey={"multi_sales_area_sync_media:menukaart-imgid"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_media:menukaart-imgidbanner"}
                  tDefault={"Category banner image"}
                  tKey={"multi_sales_area_sync_media:menukaart-imgidbanner"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_model:menukaart-sortkey"}
                  tDefault={"Sort key"}
                  tKey={"multi_sales_area_sync_model:menukaart-sortkey"}
                />
              </Collapse>
            </CardBody>
          </Card>

          <Card>
            <div style={{ display: "flex", padding: "10px 0 0 10px" }}>
              <h4>
                <TranslationWrapper tDefault={"Option Groups"} tKey={"multi_area_sync_child_settings_option_groups"} />
              </h4>
              <FormSwitch
                name={"multi_sales_area_sync:option_group"}
                tDefault={"OptionGroup"}
                tKey={"multi_sales_area_sync:option_group"}
              />
            </div>
            <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
              <Collapse in={optionGroupEnabled} sx={{ width: 1 }}>
                <FormSwitchTC
                  name={"multi_sales_area_sync_createMissing:option_group"}
                  tDefault={"Create Option Groups"}
                  tKey={"multi_sales_area_sync_createMissing:option_group"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_cascadeDelete:option_group"}
                  tDefault={"Delete Option Groups"}
                  tKey={"multi_sales_area_sync_cascadeDelete:option_group"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_model:option_group-name"}
                  tDefault={"OptionGroup name"}
                  tKey={"multi_sales_area_sync_model:option_group-name"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_model:option_group-sort_key"}
                  tDefault={"Sort key"}
                  tKey={"multi_sales_area_sync_model:option_group-sort_key"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_model:option_group-apiId"}
                  tDefault={"ApiId"}
                  tKey={"multi_sales_area_sync_model:option_group-apiId"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_model:option_group-is_active_in_pos"}
                  tDefault={"Is active in POS"}
                  tKey={"multi_sales_area_sync_model:option_group-is_active_in_pos"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_model:option_group-countable"}
                  tDefault={"Countable"}
                  tKey={"multi_sales_area_sync_model:option_group-countable"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_model:option_group-min_count"}
                  tDefault={"Min count"}
                  tKey={"multi_sales_area_sync_model:option_group-min_count"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_model:option_group-max_count"}
                  tDefault={"Max count"}
                  tKey={"multi_sales_area_sync_model:option_group-max_count"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_model:option_group-default_counts"}
                  tDefault={"Default counts"}
                  tKey={"multi_sales_area_sync_model:option_group-default_counts"}
                />

                <FormSwitchTC
                  name={"multi_sales_area_sync_pivot:option_group-product"}
                  tDefault={"Sync parent product relations"}
                  tKey={"multi_sales_area_sync_pivot:option_group-product"}
                />
                {optionGroupPivot ? (
                  <div style={{ marginLeft: "10px" }}>
                    <FormSwitchTC
                      name={"multi_sales_area_sync_model:product_option_groups-sort_key"}
                      tDefault={"Sort key"}
                      tKey={"multi_sales_area_sync_model:product_option_groups-sort_key"}
                    />
                    <FormSwitchTC
                      name={"multi_sales_area_sync_model:product_option_groups-min_count"}
                      tDefault={"Min count"}
                      tKey={"multi_sales_area_sync_model:product_option_groups-min_count"}
                    />
                    <FormSwitchTC
                      name={"multi_sales_area_sync_model:product_option_groups-max_count"}
                      tDefault={"Max count"}
                      tKey={"multi_sales_area_sync_model:product_option_groups-max_count"}
                    />
                  </div>
                ) : null}

                <FormSwitchTC
                  name={"multi_sales_area_sync_relation:option_group-child_products"}
                  tDefault={"Child product relation"}
                  tKey={"multi_sales_area_sync_relation:option_group-child_products"}
                />
                <FormSwitchTC
                  name={"multi_sales_area_sync_relation:option_group-child_product_groups"}
                  tDefault={"Child product group relation"}
                  tKey={"multi_sales_area_sync_relation:option_group-child_product_groups"}
                />
              </Collapse>
            </CardBody>
          </Card>

          <Card>
            <div style={{ display: "flex", padding: "10px 0 0 10px" }}>
              <h4>
                <TranslationWrapper
                  tDefault={"Custom Translations"}
                  tKey={"multi_area_sync_child_settings_custom_translations"}
                />
              </h4>
              <FormSwitch
                name={"multi_sales_area_sync:customizable_translation"}
                sx={{ margin: "15px 0 0 15px" }}
                tDefault={"Customizable Translations"}
                tKey={"multi_sales_area_sync:customizable_translation"}
              />
            </div>
            <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
              <Grid container spacing={1}>
                <Collapse in={customizableTranslationsEnabled} sx={{ width: 1 }}>
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:customizable_translation-orderMsg"}
                    tDefault={"Order Message"}
                    tKey={"multi_sales_area_sync_model:customizable_translation-orderMsg"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:customizable_translation-infoSplashTitle"}
                    tDefault={"Info splash title"}
                    tKey={"multi_sales_area_sync_model:customizable_translation-infoSplashTitle"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:customizable_translation-infoSplashContent"}
                    tDefault={"Info splash content"}
                    tKey={"multi_sales_area_sync_model:customizable_translation-infoSplashContent"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:customizable_translation-posIssueTxt"}
                    tDefault={"POS issue text"}
                    tKey={"multi_sales_area_sync_model:customizable_translation-posIssueTxt"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:customizable_translation-noSlotsContent"}
                    tDefault={"No slots content"}
                    tKey={"multi_sales_area_sync_model:customizable_translation-noSlotsContent"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:customizable_translation-customerOrderMessage"}
                    tDefault={"Customer order message"}
                    tKey={"multi_sales_area_sync_model:customizable_translation-customerOrderMessage"}
                  />
                </Collapse>
              </Grid>
            </CardBody>
          </Card>
          <Card>
            <Box sx={{ display: "flex", alignItems: "center", p: 1, gap: 2 }}>
              <h4>
                <TranslationWrapper tDefault={"Upsells"} tKey={"multi_area_sync_child_settings_upsells"} />
              </h4>
              <FormSwitch
                name={"multi_sales_area_sync:upsell"}
                sx={{ margin: "15px 0 0 15px" }}
                tDefault={"Upsells"}
                tKey={"multi_sales_area_sync:upsell"}
              />
            </Box>
            <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
              <Grid container spacing={1}>
                <Collapse in={upsellEnabled} sx={{ width: 1 }}>
                  <FormSwitchTC
                    name={"multi_sales_area_sync_createMissing:upsell"}
                    tDefault={"Create Upsells"}
                    tKey={"multi_sales_area_sync_createMissing:upsell"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_cascadeDelete:upsell"}
                    tDefault={"Delete Upsells"}
                    tKey={"multi_sales_area_sync_cascadeDelete:upsell"}
                  />
                </Collapse>
              </Grid>
            </CardBody>
          </Card>

          <Card>
            <Box sx={{ display: "flex", alignItems: "center", p: 1, gap: 2 }}>
              <h4>
                <TranslationWrapper
                  tDefault={"Upsell Settings"}
                  tKey={"multi_area_sync_child_settings_upsell_settings"}
                />
              </h4>
              <FormSwitch
                name={"multi_sales_area_sync:upsell_setting"}
                sx={{ margin: "15px 0 0 15px" }}
                tDefault={"Upsell settings"}
                tKey={"multi_sales_area_sync:upsell_setting"}
              />
            </Box>
            <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
              <Grid container spacing={1}>
                <Collapse in={upsellSettingEnabled} sx={{ width: 1 }}>
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:upsell_setting-is_actief"}
                    tDefault={"Upsell is active"}
                    tKey={"multi_sales_area_sync_model:upsell_setting-is_actief"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:upsell_setting-translations"}
                    tDefault={"Translations"}
                    tKey={"multi_sales_area_sync_model:upsell_setting-translations"}
                  />
                  {/* No food upsell */}
                  <h5>
                    <TranslationWrapper tDefault={" No food"} tKey={"multi_area_sync_child_settings_upsell_no_food"} />
                  </h5>
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:upsell_setting-noFood_is_actief"}
                    tDefault={"No food upsell is active"}
                    tKey={"multi_sales_area_sync_model:upsell_setting-noFood_is_actief"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:upsell_setting-noFoodTitel"}
                    tDefault={"No food upsell title"}
                    tKey={"multi_sales_area_sync_model:upsell_setting-noFoodTitel"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:upsell_setting-noFoodText"}
                    tDefault={"No food upsell text"}
                    tKey={"multi_sales_area_sync_model:upsell_setting-noFoodText"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:upsell_setting-noFoodProductIds"}
                    tDefault={"No food upsell products"}
                    tKey={"multi_sales_area_sync_model:upsell_setting-noFoodProductIds"}
                  />

                  {/* No drinks upsell */}
                  <h5>
                    <TranslationWrapper
                      tDefault={"No drinks"}
                      tKey={"multi_area_sync_child_settings_upsell_no_drinks"}
                    />
                  </h5>
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:upsell_setting-noDrinks_is_actief"}
                    tDefault={"No drinks upsell is active"}
                    tKey={"multi_sales_area_sync_model:upsell_setting-noDrinks_is_actief"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:upsell_setting-noDrinksTitel"}
                    tDefault={"No drinks upsell title"}
                    tKey={"multi_sales_area_sync_model:upsell_setting-noDrinksTitel"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:upsell_setting-noDrinksText"}
                    tDefault={"No drinks upsell text"}
                    tKey={"multi_sales_area_sync_model:upsell_setting-noDrinksText"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:upsell_setting-noDrinksProductIds"}
                    tDefault={"No drinks upsell products"}
                    tKey={"multi_sales_area_sync_model:upsell_setting-noDrinksProductIds"}
                  />

                  {/* Once upsell */}
                  <h5>
                    <TranslationWrapper
                      tDefault={"Show once"}
                      tKey={"multi_area_sync_child_settings_upsell_show_once"}
                    />
                  </h5>
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:upsell_setting-once_is_actief"}
                    tDefault={"Once upsell is active"}
                    tKey={"multi_sales_area_sync_model:upsell_setting-once_is_actief"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:upsell_setting-upsellOnFront"}
                    tDefault={"Upsell shown at"}
                    tKey={"multi_sales_area_sync_model:upsell_setting-upsellOnFront"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:upsell_setting-upsell_on_order_mode"}
                    tDefault={"Upsell orderMode"}
                    tKey={"multi_sales_area_sync_model:upsell_setting-upsell_on_order_mode"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:upsell_setting-onceTitel"}
                    tDefault={"Once upsell title"}
                    tKey={"multi_sales_area_sync_model:upsell_setting-onceTitel"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:upsell_setting-onceText"}
                    tDefault={"Once upsell text"}
                    tKey={"multi_sales_area_sync_model:upsell_setting-onceText"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:upsell_setting-onceProductIds"}
                    tDefault={"Once upsell products"}
                    tKey={"multi_sales_area_sync_model:upsell_setting-onceProductIds"}
                  />
                </Collapse>
              </Grid>
            </CardBody>
          </Card>

          <Card>
            <Box sx={{ display: "flex", alignItems: "center", p: 1, gap: 2 }}>
              <h4>
                <TranslationWrapper tDefault={"Packagings"} tKey={"multi_area_sync_packagings"} />
              </h4>
              <FormSwitch
                name={"multi_sales_area_sync:packagings"}
                sx={{ margin: "15px 0 0 15px" }}
                tDefault={"Packagings"}
                tKey={"multi_sales_area_sync:packagings"}
              />
            </Box>
            <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
              <Grid container spacing={1}>
                <Collapse in={packagingsEnabled} sx={{ width: 1 }}>
                  <FormSwitchTC
                    name={"multi_sales_area_sync_createMissing:packagings"}
                    tDefault={"Create packaging"}
                    tKey={"multi_sales_area_sync_createMissing:packagings"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_cascadeDelete:packagings"}
                    tDefault={"Delete packagings"}
                    tKey={"multi_sales_area_sync_cascadeDelete:packagings"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:packagings-name"}
                    tDefault={"Name"}
                    tKey={"multi_sales_area_sync_model:packagings-name"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:packagings-translations"}
                    tDefault={"Translations"}
                    tKey={"multi_sales_area_sync_model:packagings-translations"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:packagings-add_price_per_order"}
                    tDefault={"Add price per order"}
                    tKey={"multi_sales_area_sync_model:packagings-add_price_per_order"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:packagings-add_price_per_item"}
                    tDefault={"Add price per item"}
                    tKey={"multi_sales_area_sync_model:packagings-add_price_per_item"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:packagings-product_id"}
                    tDefault={"Packaging product (link)"}
                    tKey={"multi_sales_area_sync_model:packagings-product_id"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_pivot:packagings-product"}
                    tDefault={"Sync product relations"}
                    tKey={"multi_sales_area_sync_pivot:packagings-product"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_pivot:packagings-menukaart"}
                    tDefault={"Sync category relations"}
                    tKey={"multi_sales_area_sync_pivot:packagings-menukaart"}
                  />
                </Collapse>
              </Grid>
            </CardBody>
          </Card>

          <Card>
            <Box sx={{ display: "flex", alignItems: "center", p: 1, gap: 2 }}>
              <h4>
                <TranslationWrapper tDefault={"Packaging types"} tKey={"multi_area_sync_packaging_types"} />
              </h4>
              <FormSwitch
                disabled={packagingsEnabled}
                name={"multi_sales_area_sync:packaging_types"}
                sx={{ margin: "15px 0 0 15px" }}
                tDefault={"Packagings"}
                tKey={"multi_sales_area_sync:packaging_types"}
              />
            </Box>
            <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
              <Grid container spacing={1}>
                <Collapse in={packagingTypesEnabled} sx={{ width: 1 }}>
                  <FormSwitchTC
                    disabled={packagingsEnabled}
                    name={"multi_sales_area_sync_createMissing:packaging_types"}
                    tDefault={"Create packaging types"}
                    tKey={"multi_sales_area_sync_createMissing:packaging_types"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_cascadeDelete:packaging_types"}
                    tDefault={"Delete packaging types"}
                    tKey={"multi_sales_area_sync_cascadeDelete:packaging_types"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:packaging_types-order_mode_eat_in_enabled"}
                    tDefault={"Order mode eat-in"}
                    tKey={"multi_sales_area_sync_model:packaging_types-order_mode_eat_in_enabled"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:packaging_types-order_mode_takeaway_enabled"}
                    tDefault={"Order mode takeaway"}
                    tKey={"multi_sales_area_sync_model:packaging_types-order_mode_takeaway_enabled"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:packaging_types-name"}
                    tDefault={"Name"}
                    tKey={"multi_sales_area_sync_model:packaging_types-name"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:packaging_types-enabled"}
                    tDefault={"Enabled"}
                    tKey={"multi_sales_area_sync_model:packaging_types-enabled"}
                  />
                </Collapse>
              </Grid>
            </CardBody>
          </Card>

          <Card>
            <Box sx={{ display: "flex", alignItems: "center", p: 1, gap: 2 }}>
              <h4>
                <TranslationWrapper tDefault={"Campaigns"} tKey={"multi_area_sync_campaign"} />
              </h4>
              <FormSwitch
                name={"multi_sales_area_sync:campaign"}
                sx={{ margin: "15px 0 0 15px" }}
                tDefault={"Campaign"}
                tKey={"multi_sales_area_sync:campaign"}
              />
            </Box>
            <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
              <Grid container spacing={1}>
                <Collapse in={campaignEnabled} sx={{ width: 1 }}>
                  <FormSwitchTC
                    disabled={!campaignEnabled}
                    name={"multi_sales_area_sync_createMissing:campaign"}
                    tDefault={"Create campaigns"}
                    tKey={"multi_sales_area_sync_createMissing:campaign"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_cascadeDelete:campaign"}
                    tDefault={"Delete campaigns"}
                    tKey={"multi_sales_area_sync_cascadeDelete:campaign"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:campaign-type"}
                    tDefault={"Type"}
                    tKey={"multi_sales_area_sync_model:campaign-type"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:campaign-name"}
                    tDefault={"Name"}
                    tKey={"multi_sales_area_sync_model:campaign-name"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:campaign-api_name"}
                    tDefault={"Api Name"}
                    tKey={"multi_sales_area_sync_model:campaign-api_name"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:campaign-apiId1"}
                    tDefault={"Api ID"}
                    tKey={"multi_sales_area_sync_model:campaign-apiId1"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:campaign-is_active_in_pos"}
                    tDefault={"Active in POS"}
                    tKey={"multi_sales_area_sync_model:campaign-is_active_in_pos"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:campaign-is_active_in_jamezz"}
                    tDefault={"Active in Jamezz"}
                    tKey={"multi_sales_area_sync_model:campaign-is_active_in_jamezz"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:campaign-start_date_time"}
                    tDefault={"Start datetime"}
                    tKey={"multi_sales_area_sync_model:campaign-start_date_time"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:campaign-end_date_time"}
                    tDefault={"End datetime"}
                    tKey={"multi_sales_area_sync_model:campaign-end_date_time"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:campaign-custom_data"}
                    tDefault={"Custom data"}
                    tKey={"multi_sales_area_sync_model:campaign-custom_data"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:campaign-translations"}
                    tDefault={"Translations"}
                    tKey={"multi_sales_area_sync_model:campaign-translations"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:campaign-rawApiData"}
                    tDefault={"Raw API Data"}
                    tKey={"multi_sales_area_sync_model:campaign-rawApiData"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:campaign-x_per_group_for_y"}
                    tDefault={"X per group for Y"}
                    tKey={"multi_sales_area_sync_model:campaign-x_per_group_for_y"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_media:campaign-imgid"}
                    tDefault={"Campaign Image"}
                    tKey={"multi_sales_area_sync_media:campaign-imgid"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_media:campaign-media_in_category"}
                    tDefault={"Campaign Category Image"}
                    tKey={"multi_sales_area_sync_media:campaign-media_in_category"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_pivot:campaign-product"}
                    tDefault={"Sync product relations"}
                    tKey={"multi_sales_area_sync_pivot:campaign-product"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_pivot:campaign-category"}
                    tDefault={"Sync category relations"}
                    tKey={"multi_sales_area_sync_pivot:campaign-category"}
                  />
                  <FormSwitchTC
                    name={"multi_sales_area_sync_model:campaign-discount_product"}
                    tDefault={"Campaign discount product"}
                    tKey={"multi_sales_area_sync_model:campaign-discount_product"}
                  />
                </Collapse>
              </Grid>
            </CardBody>
          </Card>
        </Box>
      </Collapse>
    </>
  );
}

export default MultiAreaSync;
